// extracted by mini-css-extract-plugin
export default {"alertWrapper":"_30cAZqcA-f-isf8LHHdeNA"};